import { render } from "./ManagementList.vue?vue&type=template&id=09641896&scoped=true"
import script from "./ManagementList.vue?vue&type=script&lang=js"
export * from "./ManagementList.vue?vue&type=script&lang=js"

import "./ManagementList.vue?vue&type=style&index=0&id=09641896&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09641896"]])

export default __exports__